import { curry, type PlatformEvent } from 'lib/util'
import asObject from 'lib/sequence/component/children/asObject'
import { next } from 'app/_shared/events/step'
import validatePersonalStep from 'app/registration/event/validatePersonalStep'
import validateOrganisationStep from 'app/registration/event/validateOrganisationStep'

const stepValidators: Record<string, Gaia.AppModule.EventHandler> = {
  personForm: validatePersonalStep,
  organisationForm: validateOrganisationStep,
}

/**
 * Validate And Next Event Handler
 *
 * Validates the current wizard step and runs `next` if there are no errors.
 * If there are, it'll update the UI to show them.
 *
 * @param module    the current module composition object
 * @param component the current action's main component
 * @param event     the event object that triggered this handler
 */
const validateAndNext = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
): Promise<void> => {
  try {
    const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
    const { stepper } = asObject(actionComponent[G.CHILDREN])
    const { currentStep } = stepper[G.STATE]
    const validateStep = stepValidators[currentStep]

    const hasError = validateStep
      ? await validateStep(module, component, event)
      : false

    hasError
      ? module[G.ADAPTER][G.UI].update(module)
      : await next(module, component, event)
  } catch (e) {
    console.error(e)
  }
}

export default curry(validateAndNext)
